<template>
  <div class="page">
    <section class="members">
      <MemberList :members="members" />
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MemberList from "../components/members/MemberList";

export default {
  name: "Members",
  components: {
    MemberList
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
        'members'
    ]),
  },
  methods: {
  },
  created() {
  },
};
</script>

<style scoped>
.members {
  padding-bottom: 2%;
}
</style>
